/* eslint-disable no-return-assign */
import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import { get, getJson } from 'session';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';

function ViewSOAModal({ data, applicationId, showData }) {
  const setModal = useContext(ModalContext);

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
    showData(applicationId);
  };

  const token = get('token') || '';

  const authProfile = getJson('profile') || {};

  const src = `${process.env.REACT_APP_WS}${c.RPT_BUILDING_GENERATE.replace(
    '{building_application_id}',
    _.get(data, 'attributes.rptax_building_application_id')
  ).replace(
    '{transaction_id}',
    _.get(data, 'id')
  )}?bearer_token=${token}&email=${_.get(
    authProfile,
    'email'
  )}&soa_remarks=${_.get(data, 'soa_remarks')}&output=I`;

  return (
    <Modal.Body>
      <form>
        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-12">
                <iframe
                  style={{ width: '100%', height: 600, border: 'none' }}
                  title="Statement of Account"
                  src={src}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button type="button" onClick={closeModal} className="btn btn-dark ">
            <span className="font-weight-bold">Close</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

ViewSOAModal.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  applicationId: PropTypes.string.isRequired,
  showData: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ViewSOAModal);
